<nav class="navbar custom-navbar navbar-expand-lg">
  <button (click)="openSideMenu()" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
          data-target="#navbarToggleExternalContent" data-toggle="collapse" type="button">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div [class]="openMenu" class="collapse navbar-collapse" id="navbarToggleExternalContent">
    <div class="mobile-bar">
      <img class="imgLogo" src="../../../assets/images/logo-primary.svg">
      <button (click)="openSideMenu()" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
              data-target="#navbarToggleExternalContent" data-toggle="collapse" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ul class="navbar-nav">
      <!-- main -->
      <li class="nav-item">
        <a (click)="openSideMenu()" class="nav-link" routerLink="/dashboard" routerLinkActive="active">
          <i aria-hidden="true" class="fa fa-home"></i>
          <span>{{ 'side_bar.dashboard' | translate }}</span>
        </a>
      </li>
      <!-- payments -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLinkActive="active" routerLink="/payment">
          <i aria-hidden="true" class="fa fa-paper-plane"></i>
          <span>{{ 'side_bar.payment'| translate }}</span> <span *ngIf="walletBadgers?.payments > 0" class="badge">{{ walletBadgers.payments }}</span>
        </a>
      </li>
      <!-- wallet -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/wallet" routerLinkActive="active">
          <i aria-hidden="true" class="fa fa-wallet"></i>
          <span>{{ 'side_bar.wallet'| translate }}</span>
        </a>
        <!-- deposits -->
      <li class="nav-item" *ngIf="!isContractor">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/deposit" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-circle-dollar-to-slot"></i>
          <span>{{ 'side_bar.deposit' | translate }}</span><span *ngIf="walletBadgers?.deposits > 0" class="badge">{{ walletBadgers.deposits }}</span>
        </a>
      </li>
      <!-- transfer -->
      <li class="nav-item" *ngIf="walletBadgers?.transfers != -1">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/transfer" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-money-bill-transfer"></i>
          <span>{{ 'side_bar.transfer' | translate }}</span><span *ngIf="walletBadgers?.transfers > 0" class="badge">{{ walletBadgers.transfers }}</span>
        </a>
      </li>
      <!-- withdrawal -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/withdrawal" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-piggy-bank"></i>
          <span>{{ 'side_bar.withdrawal'| translate }}</span><span *ngIf="walletBadgers?.withdrawals > 0" class="badge">{{ walletBadgers.withdrawals }}</span>
        </a>
      </li>
      <!-- ukers -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/uker" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-users"></i>
          <span> {{ 'side_bar.uker'| translate }}</span><span *ngIf="userBadgers?.friends > 0" class="badge">{{ userBadgers.friends }}</span>
        </a>
      </li>
      <!-- li class="nav-item">
        <a class="nav-link" [class]="!userActive?'disabled-link':''" (click)="openSideMenu()" routerLinkActive="active" routerLink="/notification">
          <mat-icon>notifications</mat-icon>
          {{ 'side_bar.notification' | translate }}
        </a>
      </li -->
    </ul>
    <ul class="navbar-nav mt-5">
      <!-- security -->
      <li class="nav-item">
        <a (click)="openSideMenu()" class="nav-link" routerLink="/user/settings" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-gear"></i>
          <span>{{ 'side_bar.settings' | translate }}</span>
        </a>
      </li>
      <!-- user -->
      <li class="nav-item">
        <a (click)="openSideMenu()" class="nav-link" routerLink="/user/user_detail" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-user-tie"></i>
          <span>{{ 'side_bar.user_detail' | translate }}</span>
        </a>
      </li>
      <!-- company -->
      <li class="nav-item" *ngIf="!isContractor">
        <a (click)="openSideMenu()" class="nav-link" routerLink="/user/company_detail" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-building"></i>
          <span>{{ 'side_bar.company_detail' | translate }}</span>
        </a>
      </li>
      <!-- bank accounts -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/bank_account" routerLinkActive="active">
          <i aria-hidden="true" class="fas fa-building-columns"></i>
          <span>{{ 'side_bar.bank_account' | translate }}</span>
        </a>
      </li>
      <!-- stablecoin wallets -->
      <li class="nav-item">
        <a (click)="openSideMenu()" [class]="!isActive?'disabled-link':''" class="nav-link" routerLink="/stablecoin_wallet" routerLinkActive="active">
          <i aria-hidden="true" class="fa-brands fa-bitcoin"></i>
          <span>{{ 'side_bar.stablecoin_wallet' | translate }}</span>
        </a>
      </li>
      <!-- logout -->
      <li class="nav-item">
        <a (click)="logout()" class="nav-link">
          <i aria-hidden="true" class="fas fa-arrow-right-from-bracket"></i>
          <span>{{ 'side_bar.sign_out' | translate }}</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
